import { useMemo } from 'react';

const colorPalette = [
    'inherit',
    'black',
    'white',
    'slate',
    'gray',
    'zinc',
    'neutral',
    'stone',
    'red',
    'orange',
    'amber',
    'yellow',
    'lime',
    'green',
    'emerald',
    'teal',
    'cyan',
    'sky',
    'blue',
    'indigo',
    'violet',
    'purple',
    'fuchsia',
    'pink',
    'rose'
];

const colorShades = [
    50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950
];

const textSizes = [
    'xs', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', '8xl', '9xl', 'fluid-base', 'fluid-heading'
];

const useTailwind = (className: string) => {
    const hasTextColor = useMemo(
        () => {
            const colors = colorPalette.map(c => {
                if (c === 'black' || c === 'white' || c === 'inherit') {
                    return 'text-' + c;
                }
                else {
                    return colorShades.map(s => 'text-' + c + '-' + s);
                }
            });

            return colors.flat().some(cs => className.includes(cs));
        },
        [className]
    );

    const hasTextSize = useMemo(
        () => {
            return textSizes.map(s => 'text-' + s).some(ts => className.includes(ts));
        },
        [className]
    );

    const hasMaxWidth = useMemo(
        () => {
            return className.includes('max-w-');
        },
        [className]
    );

    return {
        hasTextColor: (): boolean => hasTextColor,
        hasTextSize: (): boolean => hasTextSize,
        hasMaxWidth: (): boolean => hasMaxWidth
    };
};

export { useTailwind };